import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class Row extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    data: PropTypes.any,
    hover: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {hover: false}
  }

  render() {
    const {hover} = this.state
    const {className, onClick} = this.props
    const rowClassName = classnames(
      className || 'table-row',
      {
        'is-hover': hover,
        'is-clickable': !!onClick
      }
    )

    return (
      <div
        className={rowClassName}
        onMouseEnter={this.onMouseOver}
        onMouseLeave={this.onMouseOut}
        onClick={this.onClick}
      >
        {this.props.children}
      </div>
    )
  }

  onMouseOver = () => {
    const {onMouseOver, data, hover} = this.props
    onMouseOver && onMouseOver(data)

    if (!hover) return null
    this.setState({hover: true})
  }

  onMouseOut = () => {
    const {onMouseOut, data, hover} = this.props
    onMouseOut && onMouseOut(data)

    if (!hover) return null
    this.setState({hover: false})
  }

  onClick = () => {
    const {onClick, data} = this.props
    onClick && onClick(data)
  }
}



// WEBPACK FOOTER //
// ./client/components/Table/Row.js